module.exports = __webpack_public_path__ + "static/img/xl_btn1.90a6c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/xl_btn1.png
// module id = HEHb
// module chunks = 7